<div class="form-body-desktop">
    <fr-isc-form Id="delete-config" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
    </fr-isc-form>
</div>